<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_remitDefiniteForPay"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="remitDefiniteForPay_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="getLimit('remitDefiniteForPay_serial_button')"
          @click="funcSerial()"
          >获取流水号</el-button
        >
        <el-button
          v-if="getLimit('remitDefiniteForPay_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-current-row
      highlight-hover-row
      row-id="id_remitDefiniteForPay"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isPayAdvance"
          title="运费类型"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isPayAdvance')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isPayAdvance"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.isPayAdvanceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payType"
          title="支付类型"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payType')
          "
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.payType" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.payTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isSendFund"
          title="上报状态"
          :formatter="formatterSendFundStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendFund"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in sendFundOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payStatus"
          title="支付状态"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payStatus')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.payStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in parentData.payStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运单号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="请输入运单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderNo"
          title="流水批次号"
          min-width="264"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderNo"
            placeholder="请输入流水批次号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="amount"
          title="金额（元）"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.amountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.amountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="platformCompanyName"
          title="平台开户企业"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.platformCompanyName"
            placeholder="请输入平台开户企业"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="platformBank"
          title="平台付款银行"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.platformBank"
            placeholder="请输入平台付款银行"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="platformAccount"
          title="平台银行账号"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.platformAccount"
            placeholder="请输入平台银行账号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeName"
          title="收款方"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeName"
            placeholder="请输入收款方"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeePhone"
          title="收款方电话"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeePhone"
            type="number"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeType"
          title="收款方角色"
          min-width="150"
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bankCode"
          title="收款方银行"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.bankCode"
            placeholder="请选择"
            filterable
            clearable
          >
            <el-option
              v-for="item in bankList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeAccount"
          title="收款方账号"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeAccount"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="callbackTime"
          title="到账时间"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.callbackTimeRange"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'callbackTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="modifiedByName"
          title="操作人员"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入操作人员"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="payReceiptImg"
        title="支付凭证"
        min-width="150"
        all-align="center"
      >
        <template v-slot="{ row }">
          <div
            v-if="
              row.payType == '5' ||
                row.payType == '4' ||
                row.payType == '9' ||
                row.payType == '10'
            "
          >
            <el-button @click="lookReceipt(row)">查看电子回单</el-button>
          </div>
          <div v-else>
            <el-image
              style="height:40px;line-height:3.5"
              :src="row.payReceiptImg"
              :preview-src-list="[row.payReceiptImg]"
            >
              <div slot="error" class="image-slot">
                获取失败
              </div>
            </el-image>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="100px" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              remitDefiniteForPay_edit_button &&
                scope.row.isSendFund == '0' &&
                scope.row.payType == '3'
            "
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <em class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('remitDefiniteForPay_serial_button') &&
                scope.row.payType == '10' &&
                scope.row.payStatus == '1' &&
                !scope.row.orderNo
            "
            class="item"
            effect="dark"
            content="获取流水号"
            placement="top"
          >
            <vxe-button type="text" @click="funcSerial(scope.row)">
              <em class="el-icon-document-add" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="800"
      height="740"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compEdit from "./components/remitDefiniteForPayEdit.vue";
import { electronicReceipt, queryReceiptNo } from "@/api/InternetBanking";
import request from "@/utils/request";
import { getListDict } from "@/api/commonApi";
export default {
  name: "RemitDefiniteForPayList",
  components: {
    compEdit
  },
  data() {
    return {
      callbackTimeRange: "",
      loading: false,
      tableData: [],
      dialogTableVisible: false,
      ModelCashMoney: false,
      showElectronicReceiptFlag: false,
      showElectronicReceiptUrl: "",
      modelEditFlag: false,
      modelDetailFlag: false,
      errorData: [],
      parentData: {
        payStatusOptions: [
          { label: "处理中", value: "0" },
          { label: "支付成功", value: "1" },
          { label: "支付失败", value: "2" }
        ]
      },
      exportObj: {
        exportUrl: "/ntocc-tms-api/remitDefinite/exportListForPay", //导出接口
        name: "支付明细"
      },
      listQuery: {
        callbackTimeRange: "",
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        notPayType: "6",
        payType: ""
      },
      accdata: [],
      // 机构列表
      branchList: this.$store.state.components.branchList,
      sendFundOptions: [
        { value: "0", label: "未上报" },
        { value: "1", label: "已上报" },
        { value: "2", label: "上报失败" }
      ],
      remitDefiniteForPay_search_button: true,
      remitDefiniteForPay_edit_button: true,
      bankList: []
      // Pagingconf: []
    };
  },
  created() {
    this.parentData.isPayAdvanceOptions = [
      { label: "结算运费", value: "0" },
      { label: "预付运费", value: "1" },
      { label: "充值运费", value: "2" }
    ];
    this.parentData.payTypeOptions = [
      { label: "油点", value: "1" },
      { label: "加油", value: "2" },
      { label: "转账支付", value: "3" },
      { label: "余额支付", value: "4" },
      { label: "合并支付", value: "5" },
      { label: "凭证支付", value: "9" },
      { label: "银行支付", value: "10" }
    ];
    // 获取数据字典： 银行
    getListDict({ types: "bank" }).then(response => {
      this.bankList = response.data.filter(item => item.type === "bank")[0][
        "dictList"
      ];
    });
    this.remitDefiniteForPay_search_button = this.getLimit(
      "remitDefiniteForPay_search_button"
    );
    this.remitDefiniteForPay_edit_button = this.getLimit(
      "remitDefiniteForPay_edit_button"
    );
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return request({
        url: "/ntocc-tms-api/remitDefinite/queryListForPay",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        // if(this.listQuery.total>100){
        //   this.Pagingconf = [20,30,50,100,response.data.total]
        // } else {
        //   this.Pagingconf = [20,30,50,100]
        // }
        this.loading = false;
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item1 => item1.value == cellValue
      );
      return item ? item.label : "";
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    async funcSerial(item) {
      let checkedRowArray = item
        ? [item]
        : this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message.warning("请选择需要获取的项");
        return;
      } else if (checkedRowArray.length > 20) {
        this.$message.warning("批量处理最多20条数据");
        return;
      }
      let branchCode = checkedRowArray[0].branchCode;
      let codes = [];
      for (let subItem of checkedRowArray) {
        if (subItem.branchCode != branchCode) {
          this.$message.warning("请选择同一机构");
          return;
        }
        if (
          subItem.payType != "10" ||
          subItem.payStatus != "1" ||
          subItem.orderNo
        ) {
          this.$message.warning(
            "请选择银行支付已支付成功并且未获取流水号的数据"
          );
          return;
        }
        codes.push(subItem.orderDetailCode);
      }
      codes = codes.join(",");
      const rLoading = this.openLoading();
      let response = await queryReceiptNo({ codes });
      rLoading.close();
      this.$message.success(response.msg);
      this.findList();
    },
    lookReceipt(row) {
      electronicReceipt({ code: row.code })
        .then(res => {
          let url = res.data;
          if (url) {
            window.open(url, "_blank");
          } else {
            return this.$message({ message: "暂无回单", type: "warning" });
          }
        })
        .catch(res => {});
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    formatterSendFundStatus({ cellValue }) {
      let item = this.sendFundOptions.find(item1 => item1.value == cellValue);
      return item == null ? "" : item.label;
    }
  }
};
</script>

<style lang="scss" scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
